import axios from 'axios';
import { getCSRFToken, CSRF_HEADER_NAME, needsCSRFToken } from './csrf';

export const axiosInstance = axios.create({
  withCredentials: true, // Важно для cookies
  headers: {
    'Content-Type': 'application/json',
  },
});

// CSRF-токен подставляется только для небезопасных методов
axiosInstance.interceptors.request.use(
  (config) => {
    if (config.method && needsCSRFToken(config.method)) {
      const csrfToken = getCSRFToken();
      if (csrfToken) {
        config.headers[CSRF_HEADER_NAME] = csrfToken;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// При 401 редиректим на логин: сессия истекла или отсутствует
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
